// src/components/InviteModal.jsx
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'; // اضافه کردن هوک ترجمه
import { KeyRound, ArrowLeft, ShieldAlert } from 'lucide-react';

const InviteModal = ({ isOpen, onSubmit, error }) => {
  const { t } = useTranslation(); // فراخوانی تابع t
  const [code, setCode] = useState('');

  useEffect(() => {
    if (isOpen) {
      const telegramStartParam = window.Telegram?.WebApp?.initDataUnsafe?.start_param;

      if (telegramStartParam) {
        const cleanCode = telegramStartParam.trim().toUpperCase();
        setCode(cleanCode);
      }
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (code.trim()) {
      onSubmit(code.trim().toUpperCase());
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-md">
      <div className="w-full max-w-sm p-6 bg-[#151A26] border border-white/10 rounded-3xl shadow-2xl text-right">
        <div className="flex justify-center mb-4">
          <div className="p-4 bg-emerald-500/10 rounded-2xl border border-emerald-500/20 text-emerald-400">
            <KeyRound size={32} />
          </div>
        </div>

        <h2 className="text-xl font-bold text-center text-white mb-2">
          {t('inviteTitle')}
        </h2>
        <p className="text-xs text-gray-400 text-center mb-6 leading-relaxed">
          {t('inviteDesc')}
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder={t('invitePlaceholder')}
              className="w-full px-4 py-3 bg-[#0B0E17] border border-white/10 rounded-xl text-center text-lg font-mono tracking-widest text-emerald-400 focus:outline-none focus:border-emerald-500 transition-all uppercase placeholder:normal-case placeholder:tracking-normal placeholder:text-gray-600"
              required
            />
          </div>

          {error && (
            <div className="flex items-center gap-2 p-3 bg-rose-500/10 border border-rose-500/20 rounded-xl text-rose-400 text-xs">
              <ShieldAlert size={16} className="shrink-0" />
              <span>{error}</span>
            </div>
          )}

          <button
            type="submit"
            className="w-full py-3.5 bg-gradient-to-r from-emerald-500 to-teal-500 hover:from-emerald-400 hover:to-teal-400 text-black font-bold rounded-xl shadow-lg shadow-emerald-500/20 flex items-center justify-center gap-2 transition-all active:scale-[0.98]"
          >
            <span>{t('enterApp')}</span>
            <ArrowLeft size={18} />
          </button>
        </form>
      </div>
    </div>
  );
};

export default InviteModal;